module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/fastweb-30th-scholarship-anniversary-sweepstakes-lockup-2f4c7449.png";